// Module
var code = `<span class="dropdown_input_selection">#TITLE</span>`;
// Exports
export default code;